import { useTranslation } from 'react-i18next';
import { Form, Spin } from "antd";
import { FC } from "react";
import CustomCard from "../../../../custom-card/CustomCard";
import "./academic-level-detail.scss";
interface AcademicLevelDetailProps {
  academicLevelDetail: any;
  loadingDetail: boolean;
}

const AcademicLevelDetail: FC<AcademicLevelDetailProps> = ({
  academicLevelDetail,
  loadingDetail,
}) => {
    const { t } = useTranslation();
  return (
    <section className="wrapper-settings category-management-detail" style={{height: "auto"}}>
      <div className="setting-position wrapper-inside">
        <CustomCard className="header-card" title={t("Thông tin trình độ học vấn", "Thông tin trình độ học vấn")}>
          {loadingDetail ? (
            <div className="statistic-course-content statistic-course-loading">
              <Spin size="large" />
            </div>
          ) : (
            <section>
              <Form.Item className="setting-item" name="name" label={t("Tên trình độ học vấn", "Tên trình độ học vấn")}>
                <p className="position-content">{academicLevelDetail?.name ? (t(academicLevelDetail.name, academicLevelDetail.name) as string) : ""}</p>
              </Form.Item>
              <Form.Item className="setting-item" name="code" label={t("Mã trình độ học vấn", "Mã trình độ học vấn")}>
                <p className="position-content">{academicLevelDetail?.code}</p>
              </Form.Item>
            </section>
          )}
        </CustomCard>
      </div>
    </section>
  );
};

export default AcademicLevelDetail;